import React from 'react';

const UserActivityContext = React.createContext();

export default UserActivityContext;
